import { getAvailabilityApiRoot } from './getAvailabilityApiRoot';

export function getAvailabilityUrl(group: string, company: null | '0' | '6' = null, experience: null | 'CLIENT' | 'ADVISOR' | 'EMPLOYEE' = null, publicRoute = false): string {
  const params: string[] = [];
  if (company !== null) params.push(`businessEntityCode=${company}`);
  if (experience !== null) params.push(`experienceCode=${experience}`);
  const paramsStr = params.length > 0 ? `?${params.join('&')}` : '';
  return `${getAvailabilityApiRoot(publicRoute)}/groups/${group}${paramsStr}`;
}
